import React, { useState } from "react";
import { Menu } from "@mui/material";

interface Props {
    children: React.ReactNode;
    options: React.ReactNode;
    paperClasses?: string;
    style?: React.CSSProperties;
}

const Dropdown = (props: Props) => {
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
    const [ref] = useState<string>(Math.random().toString());
    const open = anchorEl ? true : false;
    const handleMenuOpen = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div
                style={{ ...props.style }}
                id={`dropdown-${ref}`}
                aria-controls={open ? `menu-${ref}` : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleMenuOpen}
            >
                {props.children}
            </div>
            <Menu
                id={`menu-${ref}`}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ "aria-labelledby": `dropdown-${ref}` }}
                PopoverClasses={{
                    paper: props.paperClasses || "",
                }}
            >
                <div onClick={handleClose}>{props.options}</div>
            </Menu>
        </>
    );
};

export default Dropdown;
